import vhCheck from 'vh-check';

const $ = jQuery;

export default class Nav {
    constructor() {
        const $node = $('.page__header');

        $(window).scroll(event =>  {
            if ($(window).scrollTop() > $node.height()) {
                $node.addClass('page__header--sticky');
            } else {
                $node.removeClass('page__header--sticky');
            }
        }).scroll();

        // Mobile Menu toggle
        this.initMobileMenuHandling();
    }

    initMobileMenuHandling() {
        let oldHash = window.location.hash;
        $(window)
            .on('hashchange', e => {
                if (window.location.hash === '#navigation') {
                    this.onMobileMenuOpen();
                } else if (oldHash === '#navigation') {
                    this.onMobileMenuClose();
                }
                oldHash = window.location.hash;
            })
            .trigger('hashchange');
    }

    onMobileMenuOpen() {
        updateBrowserAddressbarHeight();
        $('html').addClass('site--lock-scrolling');
    }
    onMobileMenuClose() {
        $('html').removeClass('site--lock-scrolling');
    }
}

//viewport height check for iOS and Chrome android >= 56
//dynamically sets css custom property --browser-address-bar-height
function updateBrowserAddressbarHeight() {
    const vhTest = vhCheck('browser-address-bar-height');
    if (vhTest.isNeeded === false) {
        document.documentElement.style.setProperty('--browser-address-bar-height', '0px');
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/StickyNav.js